import { render } from "./SaftyTipsView.vue?vue&type=template&id=26dd1bf4"
import script from "./SaftyTipsView.vue?vue&type=script&lang=js"
export * from "./SaftyTipsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__